<template>
    <div class="tab-pane" :class="activeTab == 1 ? 'active': 'default'" id="home" role="tabpanel" aria-labelledby="home-tab">
        <div class="row justify-content-center">
            <div class="col-11 col-md-9 col-lg-5">
                <div class="form-container">
                    <form @submit.prevent="handleSubmit('form-0')" data-vv-scope="form-0">
                        <div class="form-row">
                            <div class="col-md-12">
                                <p class="form-heading">¿Que tipo de cuenta desea crear?</p>
                                <p class="advice-message">Puede escoger entre cuenta personal y empresarial</p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button :class="{ 'active': personalAccount }" @click="changeAccount" type="button" class="btn">Personal</button>
                                    <button :class="{ 'active': enterpriseAccount }" @click="changeAccount" type="button" class="btn">Empresarial</button>
                                </div>
                                <p class="advice-message advice-message-small">Con su cuenta personal recibes tus paquetes, correspondencia, revistas, etc. Si la empresa donde trabajas tiene cuenta para paquetería con CRBOX aplicable a empleados solicita el número de código asignado para que cuentes con sus beneficios.</p>
                            </div>
                        </div>
                        <h2>1. Afíliese gratis</h2>
                        <div class="form-row">
                            <div class="col-md-12">
                                <p>Código especial</p>
                                <p class="advice-message">Si posee uno porfavor ingreselo en este campo</p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <input v-model="extraParams.companyCode" type="text" class="form-control"  name="specialCode" placeholder="000-000">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <p>Crear cuenta</p>
                                <p class="advice-message">Información de acceso</p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <label v-if="personalAccount" for="" class="form-label">Nombre *</label>
                                <label v-if="enterpriseAccount" for="" class="form-label">Nombre de la empresa *</label>
                                <input v-model="Consignee.ConsigneeName" data-vv-scope="form-0" v-validate="'required'" name="firstName" type="text" :class="{ 'is-invalid': submitted && errors.has('form-0.firstName') }" class="form-control" placeholder="">
                                <div v-if="submitted && errors.has('form-0.firstName')" class="invalid-feedback">{{ errors.first('form-0.firstName') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="personalAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Primer apellido *</label>
                                <input v-model="Consignee.ConsigneeLastName1" data-vv-scope="form-0" name="apellido1" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.apellido1') }" placeholder="Pérez">
                                <div v-if="submitted && errors.has('form-0.apellido1')" class="invalid-feedback">{{ errors.first('form-0.apellido1') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="personalAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Segundo apellido *</label>
                                <input v-model="Consignee.ConsigneeLastName2" data-vv-scope="form-0" type="text" name="lastName2" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.lastName2') }" placeholder="Gonzales">
                                <div v-if="submitted && errors.has('form-0.lastName2')" class="invalid-feedback">{{ errors.first('form-0.lastName2') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="personalAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Fecha de nacimiento *</label>
                                <input v-model="Consignee.BirthDate" data-vv-scope="form-0" type="date" name="birthDate" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.birthDate') }" >
                                <div v-if="submitted && errors.has('form-0.birthDate')" class="invalid-feedback">{{ errors.first('form-0.birthDate') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="enterpriseAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Contacto de facturación *</label>
                                <input v-model="Consignee.ContactName1" data-vv-scope="form-0" v-validate="enterpriseAccount ? 'required' : null" name="contact1" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.contact1') }" placeholder="">
                                <div v-if="submitted && errors.has('form-0.contact1')" class="invalid-feedback">{{ errors.first('form-0.contact1') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="enterpriseAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Correo de facturación *</label>
                                <input v-model="Consignee.Email" data-vv-scope="form-0" v-validate="enterpriseAccount ? 'required|email' : null" name="emailContactOne" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.emailContactOne') }" placeholder="nombre@email.com">
                                <div v-if="submitted && errors.has('form-0.emailContactOne')" class="invalid-feedback">{{ errors.first('form-0.emailContactOne') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="enterpriseAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Nombre Contacto #2 *</label>
                                <input v-model="Consignee.ContactName2" data-vv-scope="form-0" v-validate="enterpriseAccount ? 'required' : null" name="contact2" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.contact2') }" placeholder="">
                                <div v-if="submitted && errors.has('form-0.contact2')" class="invalid-feedback">{{ errors.first('form-0.contact2') }}</div>
                            </div>
                        </div>
                        <div class="form-row" v-if="enterpriseAccount">
                            <div class="col-md-12">
                                <label for="" class="form-label">Correo Contact #2 *</label>
                                <input v-model="Consignee.AlternativeEmail" data-vv-scope="form-0" v-validate="enterpriseAccount ? 'required|email' : null" name="emailContact2" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.emailContact2') }" placeholder="nombre@email.com">
                                <div v-if="submitted && errors.has('form-0.emailContact2')" class="invalid-feedback">{{ errors.first('form-0.emailContact2') }}</div>
                            </div>
                        </div>
                        <div class="form-row-spacing">
                            <div v-if="personalAccount" class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Correo electrónico *</label>
                                    <input v-model="Consignee.Email" data-vv-scope="form-0" v-validate="'required|email'" name="email" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.email') }" id="inputEmail" placeholder="nombre@email.com">
                                    <div v-if="submitted && errors.has('form-0.email')" class="invalid-feedback">{{ errors.first('form-0.email') }}</div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Contraseña *</label>
                                    <input v-model="extraParams.password" type="password" data-vv-scope="form-0" v-validate="'required'" name="password" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-0.password') }" id="password" placeholder="xxxxxxxxxx">
                                    <div v-if="submitted && errors.has('form-0.password')" class="invalid-feedback">{{ errors.first('form-0.password') }}</div>
                                </div>
                            </div>
                        </div>
                        <button class="default-button default-button-form">Siguiente</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['activeTab', 'Consignee', 'extraParams', 'personalAccount', 'enterpriseAccount'],
    data () {
            return {
                submitted: false,
            }
        },
    methods: {
        handleSubmit(scope) {
            this.submitted = true;
            this.$validator.validateAll(scope).then(valid => {
                if (valid) {
                    this.extraParams.ConfirmPassword = this.extraParams.password;
                    this.extraParams.confirmEmail = this.Consignee.Email;
                    this.enterpriseAccount ? this.Consignee.IdentificationType = 'Otro' : this.Consignee.IdentificationType = 'Cedula ó Residencia';
                    this.$emit('updateConsignee', {consignee: this.Consignee, params: this.extraParams});
                }
            });
        },
        changeAccount() {
            this.$emit('updateAccount', {personalAccount: !this.personalAccount, enterpriseAccount: !this.enterpriseAccount});
        }
    }
}
</script>

